import { ProjectStructuring } from "@assets/icons/double";
import img1 from "@assets/images/selectFun1.svg";
import img2 from "@assets/images/selectFun2.svg";
import img4 from "@assets/images/selectFun4.svg";
import img5 from "@assets/images/selectFun5.svg";
import img6 from "@assets/images/selectFun6.svg";
import img7 from "@assets/images/selectFun7.svg";
import img8 from "@assets/images/selectFun8.svg";
import img9 from "@assets/images/selectFun9.svg";
import img10 from "@assets/images/selectFun10.svg";
import img11 from "@assets/images/selectFun11.svg";
import GoBack from "@components/common-components/go-back";
import { useStore } from "@stores/root-store";
import { constRoute } from "@utils/route";
import classNames from "classnames";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import CardItemsFuncImg from "../common-components/card-item-func-with-img";
import style from "./style.module.scss";
import { vercelEnv } from "@api/const";

const SelectFunction = observer(() => {
  const navigate = useNavigate();

  const {
    user: { getUserType },
  } = useStore(null);

  let userType = getUserType;

  const functionEvalDraft = (() => {
    // switch (userType) {
    //   case "basic":
    //     return "Refine a Concept Note";
    //   case "premium":
    //     return "Full Proposal Evaluator";
    //   case "enterprise":
    //     return "Full Proposal Evaluator";
    //   default:
    //     return "Refine a Concept Note or Proposal";
    // }
    return "Full Proposal Evaluator";
  })();

  const functionImgDraft = (() => {
    // switch (userType) {
    //   case "basic":
    //     return img2;
    //   case "premium":
    //     return img2;
    //   case "enterprise":
    //     return img2;
    //   default:
    //     return img1;
    // }

    return img2;
  })();

  const isTestEnv = vercelEnv !== "production";

  const btnCardsList = [
    {
      title: "Concept Note Evaluator",
      status: "",
      disable: false,
      // disable: !isTestEnv,
      // navigate: () => navigate(constRoute?.gradeSelectMode),
      navigate: () => navigate(constRoute?.gradeWelcome),
      // img: functionImgDraft,
      img: img2,
    },
    // {
    //   title: "No-Objection Procedure",
    //   status: "Demo Only",
    //   navigate: () =>
    //     navigate("/project-name/no-objection-procedure", {
    //       state: { feature: true },
    //     }),
    //   img: img10,
    //   disable: false,
    // },
    {
      title: "Annex Evaluator",
      status: "",
      navigate: () =>
        navigate("/project-name/no-objection-procedure", {
          state: { feature: true },
        }),
      img: img10,
      disable: true,
    },
    {
      title: "Climate Rationale Advisor",
      status: "Beta",
      navigate: () =>
        navigate(constRoute.rationalAdvisorWelcome, {
          state: { feature: true },
        }),
      disable: false,
      img: img4,
    },
    {
      title: "Theory of Change",
      status: "Beta",
      img: img8,
      disable: false,
      navigate: () =>
        navigate(constRoute.theoryOfChangeWelcome, {
          state: { feature: true },
        }),
    },
    {
      title: "Full Proposal Evaluator",
      status: "",
      disable: true,
      img: img6,
      navigate: () =>
        navigate(constRoute.projectStructureWelcome, {
          state: { feature: true },
        }),
    },
    // {
    //   title: "Renewable Energy Project Structuring",
    //   status: "",
    //   disable: false,
    //   img: img7,
    //   navigate: () =>
    //     navigate(constRoute.projectStructureWelcome, {
    //       state: { feature: true },
    //     }),
    // },
    {
      title: "Concept Note Converter",
      status: "",
      disable: false,
      img: img11,
      navigate: () =>
        navigate(constRoute.cnConverterWelcome, {
          state: { feature: true },
        }),
      opacity: "",
    },
  ];

  const btnCardsListArr = (() => {
    // switch (userType) {
    //   case "basic":
    //     return [
    //       btnCardsList[5],
    //       btnCardsList[4],
    //       btnCardsList[1],
    //       btnCardsList[0],
    //     ];
    //   // case "premium":
    //   //   return [...btnCardsList.slice(0, 3), ...btnCardsList.slice(-2)];
    //   case "enterprise":
    //     const enterpriseDefault = [
    //       btnCardsList[2],
    //       btnCardsList[4],
    //       btnCardsList[3],
    //       btnCardsList[0],
    //     ];
    //
    //     enterpriseDefault.push(btnCardsList[5]);
    //
    //     enterpriseDefault.push(btnCardsList[1]);
    //     return enterpriseDefault;
    //   default:
    //     return [...btnCardsList.slice(0, 2), ...btnCardsList.slice(-2)];
    // }
    const enterpriseDefault = [
      btnCardsList[2],
      btnCardsList[3],
      btnCardsList[0],
      btnCardsList[5],
      btnCardsList[4],
      btnCardsList[1],
    ];

    return enterpriseDefault;
  })();

  return (
    <div>
      <div className={style.homePagePageContainer}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflowY: "scroll",
            padding: "60px 0 100px 0",
          }}
        >
          <div className={style.homePageContainerCol}>
            <div className={style.homePageContainer}>
              <div className={style.headerContainer}>
                <h1
                  style={{
                    textAlign: "center",
                    fontSize: "34px",
                    fontWeight: "500",
                    lineHeight: "42px",
                  }}
                >
                  Select an assistant below
                </h1>
              </div>
              <div className={style.boxesContainer}>
                {btnCardsListArr?.map((item) => {
                  return <CardItemsFuncImg cardGrid={true} item={item} />;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={style.btnDiv}>
        <div className={style.twoBtnDiv}>
          <div className={style.goBackBtnDiv}>
            <GoBack onClick={constRoute?.selectDonor} className={style.goBtn} />
          </div>

          {/* <button className={style.goBtn}  onClick={() =>
           navigate(constRoute?.home)}> <img src={LeftArrow} alt="left-arrow" /> Go Back</button> */}
          {/* <button
                 onClick={() => {
                   notification.success("Save and Quit");
                   navigate(constRoute?.home);
                 }}
                 className={style.saveBtn}
               >
                 Save & Quit
               </button> */}
        </div>
      </div>
    </div>
  );
});

export default SelectFunction;
